import React from "react";

interface IconProps {
  selected?: boolean;
}

export default function VoiceCallIcon({ selected }: IconProps) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="8" fill={selected ? "#FF78AA" : "#131313"}/>
      <path 
        d="M16.75 13H19.25M21.5717 10.5H14.4283C13.64 10.5 13 11.1717 13 12V24C13 24.8283 13.64 25.5 14.4283 25.5H21.5717C22.3608 25.5 23 24.8283 23 24V12C23 11.1717 22.3608 10.5 21.5717 10.5Z" 
        stroke="white" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
}
